import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const Header = styled.span`
  margin-left: 16px;
`
